import * as React from 'react';
import clsx from 'clsx';
import * as style from './Footer.module.scss';

export type Props = {
  backgroundColor?: string;
  children?: React.ReactNode;
  color?: string;
};

const INCLUDE_FOOTER_LEGAL = false;

export const Footer: React.FC<Props> = ({
  backgroundColor,
  children,
  color,
}) => (
  <footer className={clsx(style.wrapper)}>
    <div
      className={clsx(style.container, 'container container--fhd')}
      style={{ backgroundColor, color }}>
      <div className={clsx(style.siteInfo)}>
        {children}
        {INCLUDE_FOOTER_LEGAL ? (
          <>
            <br />
            <br />

            <p>
              * NO PURCHASE NECESSARY.{' '}
              <a
                rel="noreferrer"
                target="_blank"
                href="/sweepstakes/the-pitt/index.html">
                Click to enter.
              </a>{' '}
                Open to legal residents of the 50 US and
                D.C., 18 years of age or older. Sweepstakes ends 11:59PM ET on
                2/6/26. Void where prohibited. See{' '}
              <a
                rel="noreferrer"
                target="_blank"
                href="/sweepstakes/the-pitt/rules.html">
                Official Rules
              </a>{' '}
              for details including employment/contractor requirements.
            </p>
          </>
        ) : (
          <></>
        )}
      </div>
    </div>
  </footer>
);

Footer.defaultProps = {
  backgroundColor: '#000065',
  color: '#00f0ff',
  children: `©${new Date().getFullYear()} WarnerMedia Direct, LLC. All rights reserved. HBO® and related channels and service marks are the property of Home Box Office, Inc. ©${new Date().getFullYear()} WBEI TM & ©DC. ©${new Date().getFullYear()} WBEI and ©Legendary.`,
};
